import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between w-full mb-6" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "bg-white rounded-lg shadow p-6" }

import { ref } from "vue";
import JustificationModal from "@/components/v2/Modal/JustificationModal.vue";
import EquipmentConfigurations from "./EquipmentConfigurations.vue";
import EquipmentTemplates from "./EquipmentTemplates.vue";
import EquipmentHistory from "./EquipmentHistory.vue";
import FooterActions from "@/components/v2/Tasks/Vaccination/Buttons/ActionButtons/FooterActions.vue";
import { useRouter } from "vue-router";

// ===================================================================
// State
// ===================================================================

export default /*@__PURE__*/_defineComponent({
  __name: 'EquipmentManagement',
  setup(__props) {

const activeTab = ref('configurations'); // 'configurations', 'templates', or 'history'

// ===================================================================
// Composables
// ===================================================================
const router = useRouter();

// ===================================================================
// Actions
// ===================================================================
const switchTab = (tab: string) => {
  activeTab.value = tab;
};

const handleBack = () => {
  router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(JustificationModal),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-2xl font-semibold" }, "Equipment Management", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab('configurations'))),
          class: _normalizeClass(["px-4 py-2 text-sm rounded-md", activeTab.value === 'configurations' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'])
        }, " Configurations ", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab('templates'))),
          class: _normalizeClass(["px-4 py-2 text-sm rounded-md", activeTab.value === 'templates' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'])
        }, " Add New ", 2),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (switchTab('history'))),
          class: _normalizeClass(["px-4 py-2 text-sm rounded-md", activeTab.value === 'history' ? 'bg-primary text-white' : 'bg-gray-200 text-gray-700'])
        }, " History ", 2),
        _createElementVNode("button", {
          onClick: handleBack,
          class: "text-gray-600 hover:text-gray-800 flex items-center gap-1 text-sm"
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("path", { d: "M19 12H5M12 19l-7-7 7-7" })
          ], -1),
          _createTextVNode(" Back ")
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (activeTab.value === 'configurations')
        ? (_openBlock(), _createBlock(EquipmentConfigurations, { key: 0 }))
        : (activeTab.value === 'templates')
          ? (_openBlock(), _createBlock(EquipmentTemplates, { key: 1 }))
          : (activeTab.value === 'history')
            ? (_openBlock(), _createBlock(EquipmentHistory, { key: 2 }))
            : _createCommentVNode("", true)
    ]),
    _createVNode(FooterActions, null, {
      middle: _withCtx(() => [
        _createElementVNode("button", {
          onClick: handleBack,
          class: "w-full"
        }, " Back ")
      ]),
      _: 1
    })
  ]))
}
}

})